import { CSSProperties } from "react";
import { Theme } from "../../config/themes";
import classNames, { Argument } from "classnames";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";
import "./style.scss";

interface HiddenHeadingProps {
  id?: string;
  style?: CSSProperties;
  theme?: Theme;
  className?: Argument;
  requiresFeature?: string;
  text: string;
}

/** Renders as a hidden H1, useful for screen readers and SEO. if a normal H1 isn't present on the page */
const HiddenHeading = ({
  id,
  style = {},
  className,
  theme = "white",
  requiresFeature,
  text
}: HiddenHeadingProps) => {
  const classes = classNames(
    "sr-heading",
    theme ? "theme-" + theme : "",
    className
  );
  const features = useSiteFeatures();
  return !requiresFeature || features.hasFeature(requiresFeature) ? (
    <h1 id={id} style={style} className={classes}>
      {text}
    </h1>
  ) : null;
};

export default HiddenHeading;
